import { environment } from '../../../environments/environment';
export class ApiUrlConstants {
    public static productApiUrl = environment.apiUrl + '/product';
    public static orderApiUrl = environment.apiUrl + '/order';
    public static paymentApiUrl = environment.apiUrl + '/payment';
    public static taxApiUrl = environment.apiUrl + '/tax';
    public static shippingApiUrl = environment.apiUrl + '/shipping';
    public static addressApiUrl = environment.apiUrl + '/address'; // 'http://addressapi-titandev.nextsphere.com';
    public static accountApiUrl = environment.apiUrl + '/account/V1'; // 'http://accountapi-titandev.nextsphere.com';
    public static configurationApiUrl = environment.apiUrl + '/admin/V1/';
    public static enrollSiteURL = environment.enrollSiteURL;
    public static googleMapsUrl = 'https://www.google.com/maps/place/';
    public static reBrandlyApiUrl = 'https://api.rebrandly.com/v1/';
    public static REBRANDLYAPIKEY = 'be359875aec44c0b93a3bb379e797bf7';
    public static reBrandlyDomainName = 'rebrand.ly';
    public static cmsApiURL = environment.apiUrl + '/content/v1';
    public static reportsApiURL = environment.apiUrl + '/reporttdm/v2';
}
